import styled, { css } from 'styled-components';
import { transparentize } from 'utils/color';
import { LINK } from 'constants/components';
import buttonDefaultStyle from 'components/mixins/normalize';
import { secondaryFont } from 'components/mixins/typography';

type LinkElementProps = {
  'data-test': string;
  href: string;
  layout: string;
  size: number;
  theme: any;
}

const LinkElement = styled.a.attrs((props: LinkElementProps) => ({
  href: props.href,
  'data-test': props['data-test']
}))`
  ${buttonDefaultStyle};
  text-decoration: underline;
  padding: 0;
  &:focus {
    outline: none;
  }
  ${(props: LinkElementProps) =>
    props.layout === LINK.LAYOUT.FORM &&
    css`
      ${secondaryFont};
      color: ${transparentize(props.theme.colors.textColor, 0.4)};
      font-weight: normal;
      font-size: ${props.size}px;
      &:hover,
      &:focus {
        color: ${props.theme.colors.textColor};
      }
    `};
  ${props =>
    props.layout === LINK.LAYOUT.DEFAULT &&
    css`
      color: ${props.theme.colors.textColor};
    `};
`;

export default LinkElement;
